/**
 * Created by Kirill Mashchenko on 25.01.18.
 */

pm.FlagRobotSprite = pm.ObjectSprite2D.extend(/** @lends pm.FlagRobotSprite# */{

	_type: null,

	ctor: function (type)
	{
		pm.spriteUtils.addTempSpriteFrames("Robot/{0}_flag_robot.plist".format(type));

		this._super(cc.spriteFrameCache.getSpriteFrame(this._getFrameName(type, pm.FlagRobot.State.Down)));

		this._type = type;
	},

	_getFrameName: function (type, state)
	{
		return "{0}_flag_robot_{1}.png".format(type, state);
	},

	playAnimation: function(endCallBack, target, type, args)
	{
		switch(type)
		{
			case pm.FlagRobotSprite.Animation.Up: this._up(endCallBack, target); break;
			case pm.FlagRobotSprite.Animation.Down: this._down(endCallBack, target); break;
		}
	},

	_up: function (callback, target)
	{
		this.getSprite().setSpriteFrame(this._getFrameName(this._type, pm.FlagRobot.State.Up));
		callback.call(target);
	},

	_down: function (callback, target)
	{
		this.getSprite().setSpriteFrame(this._getFrameName(this._type, pm.FlagRobot.State.Down));
		callback.call(target);
	}
});

pm.FlagRobotSprite.Type = {
	Green: "green",
	Orange: "orange"
};

pm.FlagRobotSprite.Animation = {
	Up: "up",
	Down: "down"
};

